import { useMemo } from "react";
import { useQuery } from '@tanstack/react-query';
import { GET_DATAMATES_CUSTOM_INTEGRATIONS } from "@/pages/query/constants";
import { getCustomIntegrationsPaginated } from "@/helpers/apis";

const useCustomIntegrations = ({
  shouldRefetchOnWindowFocus = false,
}: {
  shouldRefetchOnWindowFocus?: boolean;
}) => {
  const {
    data: customIntegrations,
    isLoading: isLoadingCustomIntegrations,
    isError: isCustomIntegrationsError,
  } = useQuery({
    refetchOnWindowFocus: shouldRefetchOnWindowFocus,
    staleTime: 0,
    queryKey: [GET_DATAMATES_CUSTOM_INTEGRATIONS],
    queryFn: () =>
      getCustomIntegrationsPaginated({
        page: 1,
        size: 100,
      }),
  });

  const showCustomIntegrationsEmpty = useMemo(() => {
    return (
      !isLoadingCustomIntegrations &&
      !isCustomIntegrationsError &&
      Array.isArray(customIntegrations?.items) &&
      customIntegrations.items.length === 0
    );
  }, [isLoadingCustomIntegrations, isCustomIntegrationsError, customIntegrations]);

  const showCustomIntegrationsData = useMemo(() => {
    return (
      !isLoadingCustomIntegrations &&
      !isCustomIntegrationsError &&
      Array.isArray(customIntegrations?.items) &&
      customIntegrations.items.length > 0
    );
  }, [isLoadingCustomIntegrations, isCustomIntegrationsError, customIntegrations]);

  return {
    customIntegrations,
    isLoadingCustomIntegrations,
    isCustomIntegrationsError,
    showCustomIntegrationsEmpty,
    showCustomIntegrationsData,
  };
};

export default useCustomIntegrations;
